import { BASE_API } from "../../configs/ConfigsConstants";

export async function getSubsidiarysApi(token) {
  try {
    const url = `${BASE_API}/hrm/api/get_subsidiaries/`;
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addSubsidiaryApi(data, token) {
  try {
    const url = `${BASE_API}/hrm/api/save_subsidiary/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updateSubsidiaryApi(data, token) {
  try {
    const url = `${BASE_API}/hrm/api/updates_subsidiary/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function deleteSubsidiaryApi(id, token) {
  try {
    const url = `${BASE_API}/hrm/api/delete_subsidiary/${id}/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
